import React, { useEffect } from "react";
import { isEmpty, propEq } from "ramda";
import { useLocalStorage } from "react-use";

import { useUsers } from "hooks";
import { externalRoutes } from "routes";
import UserPresenter from "presenters/UserPresenter";
import LocationInfoRepository from "repositories/LocationInfoRepository";

import useStyles from "./useStyles";

const CaliforniaDataLink = () => {
  const classes = useStyles();
  const { currentUser } = useUsers();
  const [locationInfo, setLocationInfo] = useLocalStorage("userLocationInfo", {});

  const isCaliforniaUser = propEq("country", "US") && propEq("subdivision", "CA");

  useEffect(() => {
    if (isEmpty(locationInfo)) {
      LocationInfoRepository.get().then((data) => {
        setLocationInfo(data.data);
      });
    }
  }, []);

  return isCaliforniaUser(locationInfo) ? (
    <div className={classes.californiaDataLink}>
      <a
        href={
          UserPresenter.isRegistered(currentUser)
            ? externalRoutes.californiaDataLinkPath(currentUser.email)
            : externalRoutes.californiaDataLinkPath()
        }
        target="_blank"
        rel="noreferrer"
      >
        Do Not Sell or Share My Data
      </a>
    </div>
  ) : (
    <></>
  );
};

export default CaliforniaDataLink;
